<template>
  <div class="effort-list-export-table">
    <div class="export-button-bar  mb-2 center">
      <b-button @click="showModal('Excel')" variant="info"
        >Export as Excel</b-button
      >
      <b-button
        @click="
          showModal('CSV');
          showDownloadNameModal = true;
        "
        variant="info"
        >Export as CSV</b-button
      >
      <b-modal
        v-model="showDownloadNameModal"
        :title="`Export as ${downloadFormat}`"
        ok-title="Save"
        @ok="exportToDownload"
        auto-focus-button="ok"
      >
        <b-container fluid>
          <label for="filename">Filename</label>
          <b-form-input
            v-model="exportFilename"
            id="filename"
            type="text"
          ></b-form-input>
        </b-container>
      </b-modal>
    </div>
    <div v-if="effortCount" class="text-center">
      Records from <strong>{{ effortCount }}</strong> project{{
        effortCount !== 1 ? "s" : ""
      }}.
    </div>

    <div class="container">
      <b-form-select v-model="filter" :options="filters"></b-form-select>
      <b-table
        v-if="filteredItems.length > 0"
        :items="filteredItems"
        small
      ></b-table>
      <div v-else>
        <hr />
        <span class="center">No projects were found.</span>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  props: ["items", "effortCount"],
  data: function() {
    return {
      defaultExportFilename: `project_list_${new Date().getFullYear()}_${new Date().getMonth() +
        1}_${new Date().getDate()}`,
      displayFileNameForm: false,
      showDownloadNameModal: false,
      downloadFormat: "",
      exportFilename: "",
      filter: "all",
      filters: [
        { value: "all", text: "All" },
        { value: "archived", text: "Archived" },
        { value: "live", text: "Live" },
      ],
    };
  },
  computed: {
    filteredItems() {
      if (this.filter === "archived") {
        return this.items.filter((item) => item.status === "archived");
      } else if (this.filter === "live") {
        return this.items.filter((item) => item.status === "live");
      } else {
        return this.items;
      }
    },
    filteredItemsCount() {
      this.filteredItems.length;
    },
  },
  methods: {
    showModal(format) {
      this.downloadFormat = format;
      if (this.exportFilename === "") {
        this.exportFilename = this.defaultExportFilename;
      }
      this.showDownloadNameModal = true;
    },
    exportToDownload() {
      if (this.downloadFormat === "Excel") {
        this.exportToExcel();
      } else if (this.downloadFormat === "CSV") {
        this.exportToCSV();
      }
    },
    exportToExcel() {
      // export json to Worksheet of Excel
      // only array possible
      var liveEffortRecords = XLSX.utils.json_to_sheet(
        this.items
          .filter((item) => item.status === "live")
          .map((item) => {
            var clone = { ...item };
            delete clone.status;
            return clone;
          })
      );
      var archivedEffortRecords = XLSX.utils.json_to_sheet(
        this.items
          .filter((item) => item.status === "archived")
          .map((item) => {
            var clone = { ...item };
            delete clone.status;
            return clone;
          })
      );

      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, liveEffortRecords, "Live");
      XLSX.utils.book_append_sheet(wb, archivedEffortRecords, "Archived");

      // export Excel file
      XLSX.writeFile(wb, `${this.exportFilename}.xlsx`);
    },
    exportToCSV() {
      // export json to Worksheet of Excel
      // only array possible
      var effortRecords = XLSX.utils.json_to_sheet(this.items);

      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, effortRecords, "Projects");

      // export CSV file
      XLSX.writeFile(wb, `${this.exportFilename}.csv`);
    },
  },
};
</script>

<style></style>
